module.exports = __webpack_public_path__ + "img/repositorio_unico_img2.d7f3da10.jpg";